module.exports = __webpack_public_path__ + "static/Frogsong1-3e1d99ad0ffe585d0f7816b7551207b6.png";